import { toBig } from "@tradingApp/components/Trading/helpers/big";

export function percentsToValue(
  percent: string,
  totalValue: string,
  decimal = 0,
): string {
  const percentBig = toBig(percent);
  const totalValueBig = toBig(totalValue);

  return totalValueBig.eq(0)
    ? "0"
    : percentBig.div(100).mul(totalValueBig).toFixed(decimal);
}
